import * as React from 'react';

import * as styles from './styles.css';

export function Promos({ children }: React.PropsWithChildren) {
  return (
    <div data-testid="promoList" className={styles['container']}>
      {children}
    </div>
  );
}
